import { GameResult } from '../types';

/** Survival % as shown on the leaderboard (one decimal place). */
export function displaySurvivalPercent(survivalPercentage: number): number {
  return Math.round(survivalPercentage * 10) / 10;
}

/** Duration in whole seconds for ranking. */
export function durationSeconds(duration: number): number {
  return Math.round(duration);
}

/**
 * Container daily rank: highest survival % first, then fewer pre-burns, then fastest time.
 */
export function compareContainerLeaderboardEntries(a: GameResult, b: GameResult): number {
  const survivalDiff =
    displaySurvivalPercent(b.survivalPercentage) - displaySurvivalPercent(a.survivalPercentage);
  if (survivalDiff !== 0) return survivalDiff;

  const preBurnDiff = a.preBurns - b.preBurns;
  if (preBurnDiff !== 0) return preBurnDiff;

  return durationSeconds(a.duration) - durationSeconds(b.duration);
}

export function sortContainerLeaderboard(results: GameResult[]): GameResult[] {
  return [...results].sort(compareContainerLeaderboardEntries);
}

export function isSameContainerEntry(a: GameResult, b: GameResult): boolean {
  if (a.id && b.id) return a.id === b.id;
  return (
    a.timestamp === b.timestamp &&
    displaySurvivalPercent(a.survivalPercentage) === displaySurvivalPercent(b.survivalPercentage) &&
    a.preBurns === b.preBurns &&
    durationSeconds(a.duration) === durationSeconds(b.duration)
  );
}

/** 1-based rank for a run on today's board. */
export function rankContainerEntry(results: GameResult[], entry: GameResult): number {
  const merged = sortContainerLeaderboard(
    results.some((result) => isSameContainerEntry(result, entry)) ? results : [...results, entry]
  );
  const index = merged.findIndex((result) => isSameContainerEntry(result, entry));
  return index < 0 ? merged.length : index + 1;
}
